const formatter = new Intl.NumberFormat("vi-VN", {
  style: "currency",
  currency: "VND",
});

function formatCurrency(val) {
  if (!val) return 0;

  return formatter.format(val);
}

export function genViewTemplate(value) {
  let {
    hoTen,
    hinhThuc,
    boPhan,
    luongCoBan,
    soNgayLam,
    soPhepNghi,
    phuCapAn,
    phuCapGuiXe,
    troCapBaoHiem,
    tangCa,
    thuong,
    tienBaoHiem,
    tienTamUng,
    phat,
    thucLinh,
    ghiChu,
    team,
  } = value;
  ghiChu = ghiChu || "";

  const today = new Date();
  const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const year = lastMonth.getFullYear();
  let titleSalarySlip = `Phiếu Lương Tháng ${lastMonth}-${year} - Ngày trả lương: 05-${today.getMonth()}-${today.getFullYear()}`;

  if (team.tieuDePhieuLuong?.length > 0) {
    titleSalarySlip = team.tieuDePhieuLuong;
  }

  let soNgayCongCuaThang = 0; // ?
  if (team) {
    soNgayCongCuaThang = team.soNgayCongCuaThang;
  }

  let luongThang = Number.parseInt(
    (luongCoBan / soNgayCongCuaThang) * (soNgayLam + soPhepNghi) + 0.5,
  );

  let luongCoBanStr = formatCurrency(luongCoBan);

  let luongThangStr = formatCurrency(luongThang);

  let tongKhoanNhan = Number.parseInt(
    Number.parseFloat(luongThang) +
      phuCapAn +
      phuCapGuiXe +
      tangCa +
      thuong +
      troCapBaoHiem +
      0.5,
  );

  let tongKhoanNhanStr = formatCurrency(tongKhoanNhan);

  let tongKhoanTru = formatCurrency(Number.parseInt(tienTamUng + 0.5));

  const bodyTemplate = `
    <div>
      <h2 class="title-salary">CÔNG TY TNHH CÔNG NGHỆ ONEMERCE</h2>
      <h3 class="title-salary-slip-time" style="text-align: left; margin-top: 0">
        ${titleSalarySlip}
      </h3>

      <div>
        <div>
          <p style="margin: 0.5rem 0"><b>Tên</b>:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${hoTen}</p>
          <p style="margin: 0.5rem 0"><b>Trạng thái công việc</b>:&nbsp;&nbsp;${hinhThuc}</p>
          <p style="margin: 0.5rem 0"><b>Bộ phận</b>:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${boPhan}</p>
          <p style="margin: 0.5rem 0"><b>Lương cơ bản</b>:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${luongCoBanStr}</p>
        </div>

        <div class="receipts">
          <h3 style="margin-bottom: 0.2rem"><b>Các Khoản Nhận</b></h3>
          <table class="detail" style="width: 100%; border-collapse: collapse">
            <tbody>
              <tr class="odd" style="font-size: 14px; background-color: #f2f2f2">
                <td
                  style="
                    width: 50%;
                    padding: 0.5rem;
                    border-right: 1px dotted black;
                  "
                >
                  Lương tháng
                </td>
                <td style="padding: 0.5rem; text-align: center">
                  ${luongThangStr}
                </td>
              </tr>
              <tr style="font-size: 14px">
                <td
                  style="
                    width: 50%;
                    padding: 0.5rem;
                    border-right: 1px dotted black;
                  "
                >
                  Trợ cấp ăn
                </td>
                <td style="padding: 0.5rem; text-align: center">
                  ${formatCurrency(phuCapAn)}
                </td>
              </tr>
              <tr class="odd" style="font-size: 14px; background-color: #f2f2f2">
                <td
                  style="
                    width: 50%;
                    padding: 0.5rem;
                    border-right: 1px dotted black;
                  "
                >
                  Trợ cấp đi lại
                </td>
                <td style="padding: 0.5rem; text-align: center">
                  ${formatCurrency(phuCapGuiXe)}
                </td>
              </tr>
              <tr style="font-size: 14px">
                <td
                  style="
                    width: 50%;
                    padding: 0.5rem;
                    border-right: 1px dotted black;
                  "
                >
                  Trợ cấp bảo hiểm
                </td>
                <td style="padding: 0.5rem; text-align: center">
                  ${formatCurrency(troCapBaoHiem)}
                </td>
              </tr>
              <tr class="odd" style="font-size: 14px; background-color: #f2f2f2">
                <td
                  style="
                    width: 50%;
                    padding: 0.5rem;
                    border-right: 1px dotted black;
                  "
                >
                  Tăng ca
                </td>
                <td style="padding: 0.5rem; text-align: center">
                  ${formatCurrency(tangCa)}
                </td>
              </tr>
              <tr style="font-size: 14px">
                <td
                  style="
                    width: 50%;
                    padding: 0.5rem;
                    border-right: 1px dotted black;
                  "
                >
                  Thưởng
                </td>
                <td style="padding: 0.5rem; text-align: center">
                  ${formatCurrency(thuong)}
                </td>
              </tr>
            </tbody>
          </table>
          <table
            class="count"
            style="width: 100%; border-collapse: collapse; margin-top: 0.5rem"
          >
            <tbody>
              <tr>
                <td
                  style="
                    width: 50%;
                    padding: 0.5rem;
                    border-right: 1px dotted black;
                    text-align: center;
                    font-weight: bold;
                  "
                >
                  Tổng
                </td>
                <td
                  style="
                    padding: 0.5rem;
                    text-align: center;
                    text-decoration: underline;
                  "
                >
                  ${tongKhoanNhanStr}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="deductions">
          <h3><b>Các Khoản Trừ</b></h3>
          <table class="detail" style="width: 100%; border-collapse: collapse">
            <tbody>
              <tr class="odd" style="font-size: 14px; background-color: #f2f2f2">
                <td
                  style="
                    width: 50%;
                    padding: 0.5rem;
                    border-right: 1px dotted black;
                  "
                >
                  Tiền bảo hiểm
                </td>
                <td style="padding: 0.5rem; text-align: center">
                  ${formatCurrency(tienBaoHiem)}
                </td>
              </tr>
              <tr>
                <td
                  style="
                    width: 50%;
                    padding: 0.5rem;
                    border-right: 1px dotted black;
                  "
                >
                  Tiền tạm ứng
                </td>
                <td style="padding: 0.5rem; text-align: center">
                  ${formatCurrency(tienTamUng)}
                </td>
              </tr>
              <tr class="odd" style="font-size: 14px; background-color: #f2f2f2">
                <td
                  style="
                    width: 50%;
                    padding: 0.5rem;
                    border-right: 1px dotted black;
                  "
                >
                  Tiền phạt
                </td>
                <td style="padding: 0.5rem; text-align: center">
                  ${formatCurrency(phat)}
                </td>
              </tr>
            </tbody>
          </table>
          <table
            class="count"
            style="width: 100%; border-collapse: collapse; margin-top: 0.5rem"
          >
            <tbody>
              <tr>
                <td
                  style="
                    width: 50%;
                    padding: 0.5rem;
                    border-right: 1px dotted black;
                    text-align: center;
                    font-weight: bold;
                  "
                >
                  Tổng Trừ
                </td>
                <td
                  style="
                    padding: 0.5rem;
                    text-align: center;
                    text-decoration: underline;
                  "
                >
                  ${tongKhoanTru}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="actual-salary"
          style="margin-top: 20px; background-color: #f2f2f2"
        >
          <table
            class="count"
            style="width: 100%; border-collapse: collapse; margin-top: 0.5rem"
          >
            <tbody>
              <tr>
                <td
                  style="
                    width: 50%;
                    padding: 0.5rem;
                    border-right: 1px dotted black;
                    text-align: center;
                    font-weight: bold;
                  "
                >
                  Thực Lĩnh
                </td>
                <td
                  style="
                    padding: 0.5rem;
                    text-align: center;
                    text-decoration: underline;
                  "
                >
                  ${formatCurrency(thucLinh)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br/>
        <div><strong>Ghi chú</strong>: ${ghiChu}</div>
      </div>
      <div class="statistical" style="margin-top: 1rem">
        <h3 style="margin-bottom: 0"><b>Ngày làm việc</b></h3>
        <div
          style="display: flex; flex-direction: row; column-gap: 1rem; width: 50%"
        >
          <div>
            <p style="margin: 0.5rem 0;">Số ngày lương: ${soNgayLam}</p>
            <p style="margin: 0.5rem 0;">Số phép nghỉ: ${soPhepNghi}</p>
          </div>
        </div>
      </div>
    </div>
    <br/>
    <section>
      <label style="margin-top: 1rem; padding-bottom: 0.5rem">Ký xác nhận</label>
      <p>.......................</p>
      <p>..............................................</p>
    </section>
  `;

  return bodyTemplate;
}

export async function downloadFile(content, filename) {
  return new Promise((res, rej) => {
    try {
      const html = `
      <!DOCTYPE html>
      <html lang="vi">
        <head>
          <meta charset="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <title>PHIẾU LƯƠNG</title>
        </head>
        <body>
          ${content}
        </body>
      </html>
    `;

      const blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${filename}_${new Date().toISOString()}.doc`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      res();
    } catch (err) {
      rej(err);
    }
  });
}
